<template>
  <div class="addBrand">
    <div class="topBar">
      <div class="subTitle">
        <i class="far fa-window-minimize" style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"></i>
        编辑支付方式
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px">刷新</div>
        </div>
      </div>
    </div>
    <div style="width: 1056px;margin: 0 auto">
      <div class="form-title">
        <div style="float: left;line-height: 46px;padding-left: 10px; margin-left:10px">编辑支付方式</div>
      </div>
      <div class="table">
        <div class="form">
          <div class="row">
            <el-row>
              <el-col :span="7">
                <div class="grid-content label">支付方式名称:</div>
              </el-col>
              <el-col :span="16">
                <div class="grid-content input">
                  <el-input v-model="pay_name"></el-input>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="7">
                <div class="grid-content label">appid:</div>
              </el-col>
              <el-col :span="16">
                <div class="grid-content input">
                  <el-input v-model="appid"></el-input>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="7">
                <div class="grid-content label">appkey:</div>
              </el-col>
              <el-col :span="16">
                <div class="grid-content input">
                  <el-input v-model="appkey"></el-input>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="7">
                <div class="grid-content label">排序</div>
              </el-col>
              <el-col :span="16">
                <div class="grid-content input">
                  <el-input v-model="order_by"></el-input>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="7">
                <div class="grid-content label">支付方式描述:</div>
              </el-col>
              <el-col :span="16">
                <div class="grid-content input">
                  <textarea
                    name
                    cols="30"
                    rows="10"
                    placeholder="请输入内容"
                    id="ipt"
                    v-model="pay_info"
                  ></textarea>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="7">
                <div class="grid-content label">支付手续费:</div>
              </el-col>
              <el-col :span="16">
                <div class="grid-content input">
                  <el-input v-model="service_money"></el-input>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="row" align="center">
            <div class="grid-content input">
              <button class="button" @click="submit()">提交</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return { serve: this.$store.state.serve,
      id: this.$route.params.id,
      username: "",
      token: "",
      appid: "",
      appkey: "",
      order_by: "",
      pay_info: "",
      pay_name: "",
      order_by: "",
      service_money: ""
    };
  },
  created() {
    this.$store.state.topActiveId = 7;
    this.$store.state.leftTitle = "支付设置";
    var that = this;
    this.username = this.$cookies.get("username");
    this.token = this.$cookies.get("token");

    this.axios
      .get(this.serve+"/admin/payway_info", {
        params: {
          username: this.username,
          token: this.token,
          id: this.id
        }
      })
      .then(res => {
       
        var json = res.data.data;
        if (res.data.status == "success") {
          that.appid = json.appid;
          that.appkey = json.appkey;
          that.order_by = json.order_by;
          that.pay_info = json.pay_info;
          that.pay_name = json.pay_name;
          that.service_money = json.service_money;
        }
      });
  },
  methods: {
    submit() {
      var that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      const loading = this.$loading({
        lock: true,
        text: "正在上传",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.axios
        .get(this.serve+"/admin/set_payway_info", {
          params: {
            token: this.token,
            username: this.username,
            id: this.id,
            appid: this.appid,
            appkey: this.appkey,
            order_by: this.order_by,
            pay_info: this.pay_info,
            pay_name: this.pay_name,
            service_money: this.service_money
          }
        })
        .then(res => {
        
          if (res.data.status == "success") {
            loading.close();
            this.$message({
              type:"success",
              message:'编辑成功'
            })
            that.$router.push({ path: "/admin/g_setPay" });
          }else if(res.data.code == '403'){
            that.$message.error(res.data.msg); 
            loading.close();
          } 
        })
        .catch(function(err) {
          alert("操作失败");
        });
    }
  }
};
</script>
<style lang="scss">
.addBrand {
  background: #f5f5f5;
  color: #333;
  height: 100%;
  padding-bottom: 1000px;
  #ipt {
    width: 292px;
    height: 180px;
    border: 1px solid rgba(221, 221, 221, 1);
    color: #606266;
    // outline: none;
    border-radius: 4px;
    outline-color: #24715d;
    // outline: 1px solid #24715d;
  }
  .hint {
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: #606266;
    position: absolute;
    top: 71px;
    right: 40px;
  }
  .button {
    margin: 0 auto;
  }

  .form-title {
    line-height: 46px;
    height: 46px;
  }
  .topBar {
    margin-bottom: 40px;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
  }

  .input {
    width: 100%;
    display: flex;
    align-items: baseline;
  }
  textarea {
    height: 300px;
    width: 342px;
  }
  .form-title {
    background-color: #eee;
    border: 1px solid #ddd;
  }
  .table {
    background-color: #fff;
    position: relative;
  }
  .row {
    margin-bottom: 20px;
  }
  .form {
    width: 450px;
    margin: 0 auto;
    padding: 20px 0;
  }
  .label {
    line-height: 40px;
  }
  .notice {
    font-size: 13px;
    color: #666;
    margin-top: 16px;
  }
  .button {
    border-radius: 5px;
  }
  .rutun {
    width: 78px;
    height: 28px;
    background: #fff;
    border: 1px solid rgba(221, 221, 221, 1);
    text-align: center;
    margin-top: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
  }
  .el-row {
    margin-bottom: 30px;
  }

  .switch {
    display: flex;
  }
  .el-switch {
    margin: 0 0 30px 26px;
  }
}
</style>